import { useState } from 'react';
import { Search } from 'lucide-react';
import { Button } from '../ui/button';

export default function CheckerForm({ onSubmit, error }) {
  const [url, setUrl] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!url.trim()) return;

    let formattedUrl = url.trim();
    if (!formattedUrl.startsWith('http')) {
      formattedUrl = 'https://' + formattedUrl;
    }

    onSubmit(formattedUrl);
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-2xl mx-auto">
      <div className="flex gap-3">
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://yourstore.com"
          className="flex-1 px-4 py-3 border border-slate-200 rounded-lg text-[#2C3E50] placeholder-[#94A3B8] focus:outline-none focus:ring-2 focus:ring-[#3498DB] focus:border-transparent transition-all duration-200"
          required
        />
        <Button
          type="submit"
          className="bg-[#3498DB] hover:bg-[#2980B9] text-white px-8 shadow-[0_4px_14px_0_rgba(52,152,219,0.39)]"
        >
          <Search size={18} className="mr-2" />
          Check Now
        </Button>
      </div>
      {error && (
        <p className="mt-4 text-red-500 text-center text-sm">{error}</p>
      )}
    </form>
  );
}
